import { ExerciseCategory } from '../../../api/exercise-category';

export function findExerciseCategory(
  exerciseCategories: ExerciseCategory[],
  exerciseCategoryId: string,
): ExerciseCategory[] | null {
  function recursiveHelper(
    exerciseCategory: ExerciseCategory,
    path: ExerciseCategory[] = [],
  ): ExerciseCategory[] | null {
    const newPath = [...path, exerciseCategory];

    if (exerciseCategory.id === exerciseCategoryId) return newPath;

    if (exerciseCategory.categories && exerciseCategory.categories.length > 0) {
      for (let child of exerciseCategory.categories) {
        const result = recursiveHelper(child, newPath);

        if (result) return result;
      }
    }

    return null;
  }

  for (let item of exerciseCategories) {
    const result = recursiveHelper(item);

    if (result) return result;
  }

  return null;
}
